import { motion } from 'motion/react'
import { useNavigation } from '@/contexts/NavigationProvider'
import { GameButton } from '@/components/ui/GameButton'
import { PixelIcon } from '@/components/ui/PixelIcon'

export function PauseScreen() {
  const { back, go, levelIndex } = useNavigation()

  return (
    <div className="fixed inset-0 grid place-items-center p-6" style={{ zIndex: 'var(--z-overlay)' as unknown as number }}>
      <div className="absolute inset-0 bg-black/60 backdrop-blur-md" />
      <motion.div
        initial={{ scale: 0.92, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 360, damping: 28 }}
        className="relative w-full max-w-xs rounded-[var(--r-xl)] bg-[var(--surface)] shadow-raised border border-[var(--edge)]/50 p-6"
      >
        <div className="flex items-center gap-2 mb-5">
          <PixelIcon name="pause" size={22} />
          <h2 className="font-display text-xl font-black">Paused</h2>
        </div>

        <div className="flex flex-col gap-2">
          <GameButton size="lg" icon="play" fullWidth onClick={back}>
            Resume
          </GameButton>
          {levelIndex != null && (
            <GameButton variant="secondary" icon="retry" fullWidth onClick={() => go('game', { levelIndex })}>
              Restart
            </GameButton>
          )}
          <GameButton variant="ghost" icon="settings" fullWidth onClick={() => go('settings')}>
            Settings
          </GameButton>
          <GameButton variant="ghost" icon="home" fullWidth onClick={() => go('home')}>
            Quit to Home
          </GameButton>
        </div>
      </motion.div>
    </div>
  )
}
